<template>
  <div class="cert-result-page">
    <div class="zs-wmain">
      <div class="cert-title">
        <h1>证书查询结果</h1>
        <p>Certificate Query Result</p>
      </div>

      <div class="html zhengshu-result2" v-if="inqsucess">
        <div class="award-mark" aria-hidden="true">
          <span>★</span>
        </div>

        <div class="result-status">
          <span class="success-icon"></span>
          <strong>查询成功</strong>
          <p>Certificate Found</p>
        </div>

        <div class="section-divider" aria-hidden="true">
          <span></span>
        </div>

        <div class="cert-info-list">
          <div class="cert-info-item item-small">
            <span class="label">姓名</span>
            <strong>{{ cert.name }}</strong>
          </div>
          <div class="cert-info-item item-small">
            <span class="label">性别</span>
            <strong>{{ cert.sex }}</strong>
          </div>
          <div class="cert-info-item item-small">
            <span class="label">学历</span>
            <strong>{{ cert.edu }}</strong>
          </div>
          <div class="cert-info-item item-small">
            <span class="label">出生日期</span>
            <strong>{{ cert.birth }}</strong>
          </div>
          <div class="cert-info-item item-half">
            <span class="label">证件类型</span>
            <strong>{{ cert.cardtype || cert.certtype || "居民身份证" }}</strong>
          </div>
          <div class="cert-info-item item-half">
            <span class="label">身份证号</span>
            <strong>{{ cert.cardid }}</strong>
          </div>
          <div class="cert-info-item item-full">
            <span class="label">申报专业</span>
            <strong>{{ cert.certifyname }}</strong>
          </div>
          <div class="cert-info-item item-full">
            <span class="label">申报级别</span>
            <strong>{{ cert.certifylevel }}</strong>
          </div>
          <div class="cert-info-item item-full">
            <span class="label">证书编号</span>
            <strong>{{ cert.certid }}</strong>
          </div>
          <div class="cert-info-item item-full">
            <span class="label">发证日期</span>
            <strong>{{ cert.certifydate }}</strong>
          </div>
          <div class="cert-info-item item-full">
            <span class="label">工作单位</span>
            <strong>{{ cert.workunit }}</strong>
          </div>
        </div>

        <router-link class="back-query" to="/inqcert">返回查询</router-link>
        <div class="qrcode" ref="qrCodeUrl"></div>
      </div>
    </div>
  </div>
</template>

<script>
import HeadNav from "../components/PublicComs/HeadNav";
import FootInfo from "../components/HomeComs/FootInfo.vue";
import global from "@/components/PublicComs/Common.vue";
import { Message } from "element-ui";
import QRCode from "qrcodejs2";
// console.log(window.innerWidth)
// const rate= window.innerWidth/1240;
export default {
  metaInfo: {
    title: "查询结果",
    meta: [
      {
        name: "viewport",
        content: `width=device-width, user-scalable=no, initial-scale=${1}, maximum-scale=${1}, minimum-scale=${1}`
      }
    ]
  },
  props: {},
  components: { FootInfo, HeadNav },
  data() {
    return {
      global,
      cert: {},
      result: false,
      restext: "请输入查询条件",
      plates: [],
      webConfigs: {},
      type: "",
      queryType: "人才信息",
      cardid: "",
      certid: "",
      companyname: "",
      socialcreditcode: "",
      id: "",
      inqsucess: false
    };
  },

  created() {
    let code = this.$route.query.code;
    let name = this.$route.query.name;
  },

  methods: {
    creatQrCode(code, name) {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: encodeURI(
          `${global.remoteIp}/certResult?code=${code}&name=${name}`
        ), // 需要转换为二维码的内容
        width: 150,
        height: 150,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
    }
  },

  computed: {},

  mounted() {
    let code = this.$route.query.code;
    let name = this.$route.query.name;
    this.$axios
      .get(encodeURI(`/api/certificates1/userget?certid=${code}&name=${name}`))
      .then((res) => {
        if (res.data.data.length > 0) {
          this.cert = res.data.data[0];
          this.cert.birth = getBirthDateFromIdCard(this.cert.cardid);
          this.inqsucess = true;
          this.$nextTick(() => {
            this.creatQrCode(code, name);
          });
          return;
        } else {
          this.$router.replace("/inqcert");
          Message.error("未查询到任何信息，请重新输入信息查询！");
        }
      })
      .catch((err) => {
        this.$router.replace("/inqcert");
        Message.error("未查询到任何信息，请重新输入信息查询！");
      });
    function getBirthDateFromIdCard(idCard) {
      const value = String(idCard || "").trim();
      const match = value.match(/^\d{6}(\d{4})(\d{2})(\d{2})\d{3}[\dXx]$/);
      console.log(value, match);
      if (!match) return "";

      const [, year, month, day] = match;
      const date = new Date(`${year}-${month}-${day}`);

      if (
        date.getFullYear() !== Number(year) ||
        date.getMonth() + 1 !== Number(month) ||
        date.getDate() !== Number(day)
      ) {
        return "";
      }

      return `${year}-${month}-${day}`;
    }
  },

  watch: {}
};
</script>

<style scoped>
.cert-result-page {
  position: relative;
  min-height: 100vh;
  background: #eaf7ff;
  color: #111b2f;
  font-family: "Microsoft YaHei", Arial, sans-serif;
  overflow: hidden;
}

.cert-result-page::after {
  content: "Copyright ©2022：bjrs.org.cn 北京软数信息技术研究院\A京ICP备16059467号-5";
  white-space: pre;
  position: absolute;
  left: 50%;
  bottom: 28px;
  z-index: 3;
  transform: translateX(-50%);
  width: 92%;
  color: #8994a3;
  font-size: 20px;
  line-height: 36px;
  letter-spacing: 1.4px;
  text-align: center;
}

.zs-wmain {
  position: relative;
  box-sizing: border-box;
  min-height: 100vh;
  padding: 98px 38px 170px;
  overflow: hidden;
  background: linear-gradient(180deg, #eaf7ff 0%, #f7fcff 47%, #e7f7ff 100%);
}

.zs-wmain::before,
.zs-wmain::after {
  content: "";
  position: absolute;
  z-index: 0;
  pointer-events: none;
  background-repeat: no-repeat;
  background-size: contain;
}

.zs-wmain::before {
  top: 0;
  left: 0;
  width: 100%;
  height: 545px;
  background-image: url("/static/img/info-query/top.png");
  background-position: left top;
}

.zs-wmain::after {
  right: 0;
  bottom: 0;
  width: 100%;
  height: 438px;
  background-image: url("/static/img/info-query/bottom.png");
  background-position: right bottom;
}

.cert-title {
  position: relative;
  z-index: 1;
  margin-bottom: 55px;
  text-align: center;
}

.cert-title h1 {
  margin: 0;
  color: #155dfc;
  background: linear-gradient(90deg, #155dfc 0%, #0092b8 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  letter-spacing: 1px;
}

.cert-title p {
  margin: 14px 0 0;
  color: #0062ff;
  font-size: 18px;
  line-height: 24px;
}

.zhengshu-result2 {
  position: relative;
  z-index: 1;
  width: 100%;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 109px 41px 54px;
  border-radius: 22px;
  background:
    url("/static/img/info-query/huaa.png") center 514px / 470px auto no-repeat,
    rgba(255, 255, 255, 0.93);
  box-shadow: 0 22px 48px rgba(64, 142, 215, 0.16);
}

.award-mark {
  position: absolute;
  left: 50%;
  top: -26px;
  width: 66px;
  height: 78px;
  transform: translateX(-50%);
  text-align: center;
}

.award-mark::before,
.award-mark::after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 4px;
  height: 32px;
  border-radius: 4px;
  background: linear-gradient(180deg, #58a5ff 0%, rgba(88, 165, 255, 0) 100%);
}

.award-mark::before {
  left: 24px;
}

.award-mark::after {
  right: 24px;
}

.award-mark span {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 4px solid #fff;
  border-radius: 50%;
  background: #ffb20f;
  box-shadow: 0 2px 8px rgba(225, 150, 0, 0.36);
  color: #fff;
  font-size: 18px;
  line-height: 36px;
}

.result-status {
  text-align: center;
}

.success-icon {
  position: relative;
  display: block;
  width: 64px;
  height: 64px;
  margin: 0 auto 18px;
  border-radius: 50%;
  background: #08c79a;
  box-shadow: 0 13px 22px rgba(8, 199, 154, 0.28);
}

.success-icon::before {
  content: "";
  position: absolute;
  left: 20px;
  top: 19px;
  width: 26px;
  height: 15px;
  border-left: 4px solid #fff;
  border-bottom: 4px solid #fff;
  transform: rotate(-45deg);
  border-radius: 2px;
}

.result-status strong {
  display: block;
  color: #344052;
  font-size: 24px;
  font-weight: 700;
  line-height: 34px;
}

.result-status p {
  margin: 6px 0 31px;
  color: #9aa8bb;
  font-size: 14px;
  line-height: 22px;
}

.section-divider {
  position: relative;
  height: 1px;
  margin: 0 0 34px;
  background: #e4eaf1;
}

.section-divider::before,
.section-divider::after,
.section-divider span {
  content: "";
  position: absolute;
  top: -3px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #48a9ff;
}

.section-divider::before {
  left: calc(50% - 15px);
}

.section-divider span {
  left: 50%;
  transform: translateX(-50%);
}

.section-divider::after {
  right: calc(50% - 15px);
}

.cert-info-list {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  column-gap: 38px;
  row-gap: 22px;
}

.item-small {
  grid-column: span 1;
}

.cert-info-item {
  position: relative;
  min-width: 0;
  min-height: 76px;
  box-sizing: border-box;
  padding: 0 0 12px;
  border-bottom: 1px solid rgba(159, 174, 192, 0.35);
}

.item-half {
  grid-column: span 2;
}

.item-full {
  grid-column: 1 / -1;
}

.cert-info-item .label {
  display: block;
  margin-bottom: 9px;
  color: #9aa5b8;
  font-size: 22px;
  line-height: 30px;
}

.cert-info-item strong {
  display: block;
  color: #111b2f;
  font-size: 25px;
  font-weight: 700;
  line-height: 35px;
  white-space: nowrap;
  word-break: break-all;
}

.back-query {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 73px;
  margin: 42px auto 0;
  border-radius: 14px;
  color: #fff !important;
  font-size: 24px;
  font-weight: 700;
  text-decoration: none;
  background: linear-gradient(100deg, #2f82ff 0%, #00b7d2 100%);
  box-shadow: 0 10px 18px rgba(22, 126, 220, 0.24);
}

.qrcode {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
  overflow: hidden;
}

@media (max-width: 480px) {
  .zs-wmain {
    padding: 40px 22px 136px;
  }

  .cert-result-page::after {
    font-size: 14px;
    line-height: 26px;
  }

  .zs-wmain::before {
    height: 360px;
  }

  .zs-wmain::after {
    height: 300px;
  }

  .cert-title {
    margin-bottom: 44px;
  }

  .cert-title h1 {
    font-size: 36px;
    line-height: 44px;
  }

  .cert-title p {
    font-size: 16px;
  }

  .zhengshu-result2 {
    padding: 70px 28px 40px;
    border-radius: 18px;
    background-size: 360px auto, auto;
    background-position: center 485px, center;
  }

  .cert-info-list {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    column-gap: 8px;
    row-gap: 10px;
  }

  .item-small {
    grid-column: span 1;
  }

  .item-half {
    grid-column: span 2;
  }

  .cert-info-item .label {
    font-size: 16px;
    line-height: 24px;
  }

  .cert-info-item strong {
    font-size: 18px;
    line-height: 28px;
  }

  .item-small .label {
    font-size: 15px;
  }

  .item-small strong {
    font-size: 17px;
  }

  .item-small:nth-child(4) strong,
  .item-half:nth-child(6) strong {
    font-size: 15px;
    letter-spacing: 0;
  }
}

@media (max-width: 360px) {
  .zs-wmain {
    padding-left: 16px;
    padding-right: 16px;
  }

  .zhengshu-result2 {
    padding-left: 20px;
    padding-right: 20px;
  }

  .cert-info-list {
    column-gap: 6px;
  }

  .item-small:nth-child(4) strong,
  .item-half:nth-child(6) strong {
    font-size: 11px;
  }
}
</style>
